import { BossModeTrack } from '../../types';

export type BossModeTrackTable = Pick<
  BossModeTrack,
  | 'eventType'
  | 'user'
  | 'lead'
  | 'listing'
  | 'previousNdaStatus'
  | 'newNdaStatus'
  | 'createdAt'
>;

export type BossModeTrackTableKeys = Array<keyof BossModeTrackTable>;

export const TABLE_COLUMNS: BossModeTrackTableKeys = [
  'eventType',
  'user',
  'lead',
  'listing',
  'previousNdaStatus',
  'newNdaStatus',
  'createdAt',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  eventType: 'eventType',
  user: 'user',
  lead: 'lead',
  listing: 'listing',
  previousNdaStatus: 'previousNdaStatus',
  newNdaStatus: 'newNdaStatus',
  createdAt: 'time',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  createdAt: 130,
};
